/**
 * The global unique key to store the cancel token in the request config.
 */
export var CANCEL_KEYS = '__docs_http_cancel_key__';